// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Client from "@apollo/client";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

function arrayKeepUniqueBy(collection, predicate) {
  return collection.filter((current, index) => Stdlib_Array.findIndexOpt(collection, element => predicate(element, current)) === index);
}

let Raw = {};

let query = Client.gql(["query PricesQuery($after: String)  {\nprices(first: 50, after: $after)  {\n__typename  \npageInfo  {\n__typename  \nendCursor  \nhasNextPage  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \nenableByDefault  \n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.prices;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.endCursor;
  let value$4 = value$2.hasNextPage;
  let value$5 = value$1.edges;
  return {
    prices: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        endCursor: !(value$3 == null) ? value$3 : undefined,
        hasNextPage: !(value$4 == null) ? value$4 : undefined
      },
      edges: value$5.map(value => {
        let value$1 = value.node;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            enableByDefault: value$1.enableByDefault
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.prices;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.enableByDefault;
    let value$3 = value$1.name;
    let value$4 = value$1.id;
    let value$5 = value$1.__typename;
    let node = {
      __typename: value$5,
      id: value$4,
      name: value$3,
      enableByDefault: value$2
    };
    let value$6 = value.__typename;
    return {
      __typename: value$6,
      node: node
    };
  });
  let value$3 = value$1.pageInfo;
  let value$4 = value$3.hasNextPage;
  let hasNextPage = value$4 !== undefined ? value$4 : null;
  let value$5 = value$3.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$3.__typename;
  let pageInfo = {
    __typename: value$6,
    endCursor: endCursor,
    hasNextPage: hasNextPage
  };
  let value$7 = value$1.__typename;
  let prices = {
    __typename: value$7,
    pageInfo: pageInfo,
    edges: edges
  };
  return {
    prices: prices
  };
}

function serializeVariables(inp) {
  let a = inp.after;
  return {
    after: a !== undefined ? a : undefined
  };
}

function makeVariables(after) {
  return {
    after: after
  };
}

function makeDefaultVariables() {
  return {
    after: undefined
  };
}

let PricesQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let PricesQuery_refetchQueryDescription = include.refetchQueryDescription;

let PricesQuery_use = include.use;

let PricesQuery_useLazy = include.useLazy;

let PricesQuery_useLazyWithVariables = include.useLazyWithVariables;

let PricesQuery = {
  PricesQuery_inner: PricesQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: PricesQuery_refetchQueryDescription,
  use: PricesQuery_use,
  useLazy: PricesQuery_useLazy,
  useLazyWithVariables: PricesQuery_useLazyWithVariables
};

function makePriceNamesDataset(prices) {
  let uniquePriceNames = arrayKeepUniqueBy(prices.map(param => param.node.name), (a, b) => a === b);
  let defaultPriceName = Stdlib_Array.reduce(prices, [
      undefined,
      0
    ], (acc, param) => {
      let price = param.node;
      let occurrences = prices.filter(param => {
        let current = param.node;
        if (current.name === price.name && current.enableByDefault) {
          return price.enableByDefault;
        } else {
          return false;
        }
      }).length;
      if (occurrences > acc[1]) {
        return [
          price.name,
          occurrences
        ];
      } else {
        return acc;
      }
    })[0];
  return {
    priceNames: uniquePriceNames,
    defaultPriceName: defaultPriceName
  };
}

function runScanPrices(pricesFetch, cursor, dataOpt, onDone, param) {
  let data = dataOpt !== undefined ? dataOpt : [];
  Future.mapOk(FuturePromise.fromPromise(pricesFetch(cursor)), undefined, response => {
    if (response.TAG !== "Ok") {
      return onDone("Error");
    }
    let match = response._0;
    let match$1 = match.data.prices;
    let match$2 = match$1.pageInfo;
    let match$3 = match$2.hasNextPage;
    if (match$3 !== undefined && match$3) {
      if (match.error !== undefined) {
        return onDone("Error");
      } else {
        return runScanPrices(pricesFetch, match$2.endCursor, Belt_Array.concatMany([
          data,
          match$1.edges
        ]), onDone, undefined);
      }
    }
    if (match.error !== undefined) {
      return onDone("Error");
    } else {
      return onDone({
        TAG: "Success",
        _0: Belt_Array.concatMany([
          data,
          match$1.edges
        ])
      });
    }
  });
}

function PromotionEditPriceNameSelect(props) {
  let onChange = props.onChange;
  let value = props.value;
  let __required = props.required;
  let required = __required !== undefined ? __required : false;
  let apolloClient = ReasonMLCommunity__ApolloClient.React.useApolloClient();
  let match = React.useState(() => "Loading");
  let setStatus = match[1];
  let status = match[0];
  React.useEffect(() => {
    let pricesFetch = after => apolloClient.rescript_query({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    }, undefined, undefined, "NetworkOnly", undefined, {
      after: after
    });
    runScanPrices(pricesFetch, undefined, undefined, result => setStatus(param => result), undefined);
  }, []);
  let match$1 = React.useMemo(() => {
    if (typeof status !== "object") {
      if (status === "Loading") {
        return [
          [],
          undefined
        ];
      } else {
        return [
          [],
          undefined
        ];
      }
    }
    let result = makePriceNamesDataset(status._0);
    return [
      result.priceNames,
      result.defaultPriceName
    ];
  }, [status]);
  let defaultPriceName = match$1[1];
  let priceNames = match$1[0];
  React.useEffect(() => {
    if (value === "") {
      if (defaultPriceName !== undefined) {
        onChange(defaultPriceName);
      }
    }
  }, [defaultPriceName]);
  let items = priceNames.map(priceName => ({
    TAG: "Option",
    key: priceName,
    label: priceName,
    value: priceName
  }));
  return JsxRuntime.jsx(Select.make, {
    label: I18n.t("Price list"),
    placeholder: priceNames.length !== 0 ? I18n.t("Select a price list") : I18n.t("Loading..."),
    preset: {
      NAME: "inputField",
      VAL: {
        required: required,
        errorMessage: props.errorMessage
      }
    },
    disabled: priceNames.length === 0,
    sections: [{
        items: items
      }],
    value: {
      TAG: "Single",
      _0: value
    },
    onChange: change => {
      if (change.TAG === "Single") {
        return onChange(change._0);
      }
    }
  });
}

let make = React.memo(PromotionEditPriceNameSelect);

export {
  arrayKeepUniqueBy,
  PricesQuery,
  makePriceNamesDataset,
  runScanPrices,
  make,
}
/* query Not a pure module */
